import { ListTicketViewRef } from 'app/pages/NewAccount/types';
import React, {
  Dispatch,
  forwardRef,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import ListOrderLayout from '../ListOrderLayout';
import useListOrder from '../useListOrder';
import { TAB_ORDER_MANAGEMENT } from '..';
export type ListOPrderManagementViewProps = {
  activeKeyTab: TAB_ORDER_MANAGEMENT;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
};

const ListOrderSuccess = forwardRef<
  ListTicketViewRef,
  ListOPrderManagementViewProps
>(({ activeKeyTab, loading, setLoading }, ref) => {
  const isActiveCurrentTab = activeKeyTab === TAB_ORDER_MANAGEMENT.THANH_CONG;
  const [isDisplayData, setIsDisplayData] = useState(isActiveCurrentTab);

  const { listOrder, paginator, search, optionsGetListOrder } = useListOrder({
    orderState: 'success',
    isActiveTab: isActiveCurrentTab,
    setLoading,
    onFinally: () => {
      setIsDisplayData(true);
    },
  });
  useImperativeHandle(ref, () => {
    return {
      search,
      getCurrentSearchOpt: () => optionsGetListOrder,
    };
  });

  useEffect(() => {
    if (!isActiveCurrentTab) setIsDisplayData(false);
  }, [isActiveCurrentTab]);

  return (
    <ListOrderLayout
      loading={loading}
      paginator={paginator}
      listOrder={isDisplayData ? listOrder || [] : []}
      search={search}
      orderState={activeKeyTab}
      setIsLoading={setLoading}
      activeKeyTab={activeKeyTab}
    />
  );
});

export default ListOrderSuccess;
